import { StudentAssignmentResponse } from "shared/types/studentTypes"
import { AssignmentResponse } from "shared/types/teacherTypes"

export const isStudentAssignments = (isStudent: boolean, assignments: AssignmentResponse[] | StudentAssignmentResponse[]): assignments is StudentAssignmentResponse[] => {
    return isStudent
}
